import type * as Types from '../../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateNoteMutationVariables = Types.Exact<{
  noteInput: Types.DigitalCastNoteCreateInput;
}>;


export type CreateNoteMutationPage = { readonly __typename?: 'RootMutationType', readonly createDigitalCastNote: { readonly __typename?: 'DigitalCastNote', readonly id: string, readonly text: string, readonly noteDate: string, readonly companyId: string } };

export type UpdateNoteMutationVariables = Types.Exact<{
  noteInput: Types.DigitalCastNoteUpdateInput;
}>;


export type UpdateNoteMutationPage = { readonly __typename?: 'RootMutationType', readonly updateDigitalCastNote: { readonly __typename?: 'DigitalCastNote', readonly id: string, readonly text: string, readonly noteDate: string, readonly companyId: string } };

export type DeleteNoteMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DeleteNoteMutationPage = { readonly __typename?: 'RootMutationType', readonly deleteDigitalCastNote: boolean };


export const CreateNoteDocument = gql`
    mutation CreateNote($noteInput: DigitalCastNoteCreateInput!) {
  createDigitalCastNote(noteInput: $noteInput) {
    id
    text
    noteDate
    companyId
  }
}
    `;
export type CreateNoteMutationFn = Apollo.MutationFunction<CreateNoteMutationPage, CreateNoteMutationVariables>;

/**
 * __useCreateNoteMutation__
 *
 * To run a mutation, you first call `useCreateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNoteMutation, { data, loading, error }] = useCreateNoteMutation({
 *   variables: {
 *      noteInput: // value for 'noteInput'
 *   },
 * });
 */
export function useCreateNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateNoteMutationPage, CreateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNoteMutationPage, CreateNoteMutationVariables>(CreateNoteDocument, options);
      }
export type CreateNoteMutationHookResult = ReturnType<typeof useCreateNoteMutation>;
export type CreateNoteMutationResult = Apollo.MutationResult<CreateNoteMutationPage>;
export type CreateNoteMutationOptions = Apollo.BaseMutationOptions<CreateNoteMutationPage, CreateNoteMutationVariables>;
export const UpdateNoteDocument = gql`
    mutation UpdateNote($noteInput: DigitalCastNoteUpdateInput!) {
  updateDigitalCastNote(noteInput: $noteInput) {
    id
    text
    noteDate
    companyId
  }
}
    `;
export type UpdateNoteMutationFn = Apollo.MutationFunction<UpdateNoteMutationPage, UpdateNoteMutationVariables>;

/**
 * __useUpdateNoteMutation__
 *
 * To run a mutation, you first call `useUpdateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNoteMutation, { data, loading, error }] = useUpdateNoteMutation({
 *   variables: {
 *      noteInput: // value for 'noteInput'
 *   },
 * });
 */
export function useUpdateNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNoteMutationPage, UpdateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNoteMutationPage, UpdateNoteMutationVariables>(UpdateNoteDocument, options);
      }
export type UpdateNoteMutationHookResult = ReturnType<typeof useUpdateNoteMutation>;
export type UpdateNoteMutationResult = Apollo.MutationResult<UpdateNoteMutationPage>;
export type UpdateNoteMutationOptions = Apollo.BaseMutationOptions<UpdateNoteMutationPage, UpdateNoteMutationVariables>;
export const DeleteNoteDocument = gql`
    mutation DeleteNote($id: ID!) {
  deleteDigitalCastNote(id: $id)
}
    `;
export type DeleteNoteMutationFn = Apollo.MutationFunction<DeleteNoteMutationPage, DeleteNoteMutationVariables>;

/**
 * __useDeleteNoteMutation__
 *
 * To run a mutation, you first call `useDeleteNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNoteMutation, { data, loading, error }] = useDeleteNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteNoteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNoteMutationPage, DeleteNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNoteMutationPage, DeleteNoteMutationVariables>(DeleteNoteDocument, options);
      }
export type DeleteNoteMutationHookResult = ReturnType<typeof useDeleteNoteMutation>;
export type DeleteNoteMutationResult = Apollo.MutationResult<DeleteNoteMutationPage>;
export type DeleteNoteMutationOptions = Apollo.BaseMutationOptions<DeleteNoteMutationPage, DeleteNoteMutationVariables>;